import React, { useState } from 'react';
import { connect } from 'react-redux'
import { Field, reduxForm,initialize  } from 'redux-form';
import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import {
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  Paper,
  Checkbox,
  CircularProgress
} from '@material-ui/core';
import { useStyles } from './styles';
import { FormActionButtons } from "components";
import { useQuery } from '@apollo/react-hooks';
import { GET_RATE_PLANS } from 'graphql/queries/accommodations';


const RenderCheckbox = ({ input, meta, ...rest }) => {
  return (
    <Checkbox
      checked={input.value ? true : false}
      onChange={input.onChange}
      {...rest}
    />
  );
};

const FuturePrices = ({ 
    handleSubmit,
    setSubmitButton,
    isUpdate,
    onSubmit, 
    initialValues,
    businessOwner
}) => {
  

  const [selectedRows, setSelectedRows] = useState({});
  const classes = useStyles();


   const { loading, data,error} = useQuery(GET_RATE_PLANS, {
    variables: {
      businessOwnerId:
        businessOwner.selectedBusinessOwner.ownerId ||
        businessOwner.selectedBusinessOwner.id
    },
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true
  });
 
  const handleRowSelection = (ratePlanId, isChecked) => {
    setSelectedRows(prev => ({
      ...prev,
      ratePlanId
    }));
  };


  const submitForm = (formValues) => {
  
    const selectedIds = Object.keys(formValues)
      .filter(key => key.startsWith('selected_') && formValues[key])
      .map(key => key.replace('selected_', ''));

    onSubmit({ futureRatePlanIds: selectedIds }, 'futurePricesForm');
  };
  
  if (loading) return <CircularProgress />;
  if (error) return <Typography color="error">Error loading rate plans</Typography>;

  return (
    <form onSubmit={handleSubmit(submitForm)} className={classes.wrapper}>
      <Button
        className={classes.createNewBtn}
        onClick={() => (window.location.href = '/rate-plan')}
      >
        <AddCircleOutlineIcon className={classes.createNewIcon} />
        <Typography className={classes.btnTitle}>
          Create new rate plan
        </Typography>
      </Button>

      <Typography
        variant="body1"
        style={{
          cursor: 'pointer',
          margin: '10px 12px'
        }}
      >
        Select Your Rate Plan
      </Typography>

      <TableContainer
        component={Paper}
        style={{
          marginBottom: '50px'
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Rate Plans</TableCell>
              <TableCell>Start Date</TableCell>
              <TableCell>End Date</TableCell>
              <TableCell>USD</TableCell>
              <TableCell>EUR</TableCell>
              <TableCell>NOR</TableCell>
              <TableCell>Select</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.ratePlans?.map(ratePlan => {
              const usdPrice = ratePlan.prices.find(
                p => p.currency.currency === 'USD'
              )?.value;
              const eurPrice = ratePlan.prices.find(
                p => p.currency.currency === 'EUR'
              )?.value;
              const norPrice = ratePlan.prices.find(
                p => p.currency.currency === 'NOK'
              )?.value;
              const firstPrice = ratePlan.prices[0];

              return (
                <TableRow
                  key={ratePlan.id}
                  style={{
                    backgroundColor: selectedRows[ratePlan.id]
                      ? '#e2f5f8'
                      : 'inherit'
                  }}
                >
                  <TableCell>{ratePlan.title}</TableCell>
                  <TableCell>{firstPrice?.startDate}</TableCell>
                  <TableCell>{firstPrice?.endDate}</TableCell>
                  <TableCell>{usdPrice || '-'}</TableCell>
                  <TableCell>{eurPrice || '-'}</TableCell>
                  <TableCell>{norPrice || '-'}</TableCell>
                  <TableCell>
                    <Field
                      name={`${ratePlan.id}`}
                      component={RenderCheckbox}
                      onChange={(e, isChecked) =>
                        handleRowSelection(ratePlan.id, isChecked)
                      }
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <FormActionButtons
        cancelPath="/accommodations-and-activities"
        actionLabel="Next"
        setSubmitButton={setSubmitButton}
        isUpdate={isUpdate}
      />
    </form>
  );
};

const mapStateToProps = (state, ownProps) => {
  
  
  const { existingFutureRatePlanIds } = ownProps;

  const initialValues = {};
  if (existingFutureRatePlanIds && existingFutureRatePlanIds.length) {
    existingFutureRatePlanIds.forEach(id => {
      initialValues[`${id}`] = true;
    });
  }

  
  return { initialValues,
    futurePricesForm: state.form.futurePricesForm,
    businessOwner: state.businessOwner
   };
};


export default connect(mapStateToProps)(
  reduxForm({
    form: 'futurePricesForm',
    enableReinitialize: true, 
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  })(FuturePrices)
);